import React from 'react';
import PropTypes from 'prop-types';
import * as smartYugikiList from '../../../constants/common/ConstSmartYugiki';
import * as commonLogic from '../../../logic/CommonLogic';
import SelectModalPanel from './SelectModalPanel';

/**
 * SelectSmartYugiki
 */
class SelectSmartYugiki extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      smartYugiki: this.props.data.smartYugiki,
      masterList: []
    };
    this.handleModalShowChange = this.handleModalShowChange.bind(this);
    this.isModalOpen = false;
  }

  /**
   * メーカー選択画面を表示する
   */
  handleModalShowChange(checkedList) {
    if (this.isModalOpen) {
      this.isModalOpen = false;
      if (checkedList != null && checkedList != undefined) {
        this.props.data.smartYugikiIds = checkedList;
      }
      this.setState({ masterList: [] });
      $('#modal_smart_yugi_select_panel').hide();
    } else {
      this.isModalOpen = true;
      this.setState({ masterList: commonLogic.deepCopy(smartYugikiList.SMARTYUGIKI) });
      $('#modal_smart_yugi_select_panel').show();
    }
  }

  render() {
    // const actions = this.props.actions;

    // // スマート遊技機フラグのリストに、画面表示用の"すべて"を追加する。
    // let displayItemList = [{ smart_flag: '', smart_flag_mei: 'すべて' }];
    // if (smartYugikiList.SMARTYUGIKI.length > 0) {
    //   let j = 1;
    //   for (let i = 0; i < smartYugikiList.SMARTYUGIKI.length; i++) {
    //     displayItemList[j++] = smartYugikiList.SMARTYUGIKI[i];
    //   }
    // }

    // // リストボックスの中身
    // const nodes = displayItemList.map((item) => {
    //   return (
    //     <option value={item.smart_flag} key={item.smart_flag}>
    //       {item.smart_flag_mei}
    //     </option>
    //   );
    // });
    // const smartYugiki = this.props.data.smartYugiki;
    let SelectModalPanelNodes = null;
    if (this.state.masterList.length != 0) {
      SelectModalPanelNodes = (
        <SelectModalPanel
          masterList={this.state.masterList}
          handleModalShowChange={this.handleModalShowChange}
          modalTitle={'スマート遊戯機'}
          allCheckText={'すべて'}
          checkedList={this.props.data.smartYugikiIds}
          idKey={'smart_flag'}
          valueKey={'smart_flag_mei'}
        />
      );
    }

    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable">
          <p>スマート遊技機</p>
        </div>
        <label className="select_panel_content_parent" onClick={() => this.handleModalShowChange()}>
          <div id="selectSmartYugi" className="select_smart_yugi_content">
            <p>ddd</p>
          </div>
        </label>


        <div id="modal_smart_yugi_select_panel" className="modal_select_panel">
          {SelectModalPanelNodes}
        </div>
      </div>
    );
  }
}

SelectSmartYugiki.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectSmartYugiki;
